function finiteNumber(value: unknown): number {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

export function formatWorkspaceMoney(
  value: unknown,
  unit = 'currency',
  currency: unknown = 'USD',
): string {
  if (unit === 'ratio') {
    return new Intl.NumberFormat('en-US', {
      style: 'percent',
      maximumFractionDigits: 1,
    }).format(finiteNumber(value))
  }
  const currencyCode = typeof currency === 'string' && /^[A-Z]{3}$/.test(currency)
    ? currency
    : 'USD'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    notation: Math.abs(finiteNumber(value)) >= 100_000 ? 'compact' : 'standard',
    maximumFractionDigits: 0,
  }).format(finiteNumber(value))
}
